import {ReloadButton} from '@flexinet/ui-components';

import {Box} from '@mantine/core';

import {useQueryClient} from '@tanstack/react-query';

import {setupIntentsKeys} from '../hooks/useSetupIntentsQuery';

/**
 * FNP-918: reload the setup-intents list.
 *
 * ⚠️ This used to call `fetchRecords()` from the list hook. Under the old
 * `useQuery` that invalidated the list; under `useInfiniteQuery` the same name
 * means FETCH THE NEXT PAGE. Wiring Reload to it would have appended a page
 * instead of refreshing — the button would keep loading MORE rows and never
 * re-read the ones on screen.
 *
 * Invalidating the module key is the reload: react-query refetches every loaded
 * page of the active list, so the operator keeps their scroll position and sees
 * fresh data. It also avoids depending on the list hook at all — the old button
 * called `useSetupIntents()` purely to reach one function, which spun up a
 * second query instance (and, before the module-scoped stores, a second private
 * copy of the keyword).
 */
export const ReloadRecordsButton = () => {

    const queryClient = useQueryClient();

    return (
        <Box mx='s'>
            <ReloadButton
                onClick={() =>
                    queryClient.invalidateQueries({queryKey: setupIntentsKeys.all})}
            />
        </Box>
    );
};
